"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailAddressFactory = void 0;
const Factory = require("factory.ts");
const persona_1 = require("../../../../mocks/persona");
exports.emailAddressFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    address: persona_1.persona.email,
});
